// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Kp_Qi","requiredAsterisk":"Info_requiredAsterisk__3xzmj"};